import React from "react";
import { Box, Grid, Paper, Stack, Typography } from "convertupleads-theme";
import DefaultButton from "./ContainedBtnComponents/DefaultButton";
import DefaultButtonSmall from "./ContainedBtnComponents/DefaultButtonSmall";
import DefaultButtonLarge from "./ContainedBtnComponents/DefaultButtonLarge";
import DefaultButtonWithStartIcon from "./ContainedBtnComponents/DefaultButtonWithStartIcon";
import DefaultButtonWithEndIcon from "./ContainedBtnComponents/DefaultButtonWithEndIcon";
import DefaultLoadingButton from "./ContainedBtnComponents/DefaultLoadingButton";
import DefaultButtonDisabled from "./ContainedBtnComponents/DefaultButtonDisabled";
import DefaultBtnWithIcons from "./ContainedBtnComponents/DefaultBtnWithIcons";

const ContainedButtons = () => {
  return (
    <Stack spacing={2} p={3}>
      <Box>
        <Typography variant={"h6"} color={"text.primary"}>
          Contained Button
        </Typography>
        <Typography variant={"body2"} color={"text.primary"}>
          this is the default button.
        </Typography>
      </Box>
      <Paper
        elevation={0}
        sx={{
          width: "80%",
          alignSelf: "center",
        }}
      >
        <Grid container rowSpacing={2} columnSpacing={2}>
          <Grid item xs={6}>
            <DefaultButtonLarge />
          </Grid>
          <Grid item xs={6}>
            <DefaultButton />
          </Grid>
          <Grid item xs={6}>
            <DefaultButtonSmall />
          </Grid>
          <Grid item xs={6}>
            <DefaultButtonDisabled />
          </Grid>
          <Grid item xs={6}>
            <DefaultButtonWithStartIcon />
          </Grid>
          <Grid item xs={6}>
            <DefaultButtonWithEndIcon />
          </Grid>
          <Grid item xs={6}>
            <DefaultBtnWithIcons />
          </Grid>
          <Grid item xs={6}>
            <DefaultLoadingButton />
          </Grid>
        </Grid>
      </Paper>
    </Stack>
  );
};

export default ContainedButtons;
